import { addEntity } from '@/lib/entity/addEntity'
import { removeEntityById } from '@/lib/entity/removeEntityById'
import { replaceEntityById } from '@/lib/entity/replaceEntityById'
import { IAction } from '@/redux/actions/action-helpers'
import { CompanyHotelProgramsTypes } from '@/redux/actions/actions.types'
import { ApplicationState } from '@/redux/stores/types'

export function companyHotelProgramsReducer(state: ApplicationState['companyHotelPrograms'] = [], action: IAction) {
	switch (action.type) {
		case CompanyHotelProgramsTypes.GetCompanyHotelPrograms.SUCCESS:
			return action.payload
		case CompanyHotelProgramsTypes.CreateCompanyHotelProgram.SUCCESS:
			return addEntity(state, action.payload)
		case CompanyHotelProgramsTypes.UpdateCompanyHotelProgram.SUCCESS:
			return replaceEntityById(state, action.payload)
		case CompanyHotelProgramsTypes.DeleteCompanyHotelProgram.SUCCESS:
			return removeEntityById(state, action.requestPayload.id)
		default:
			return state
	}
}
